import React from "react";
import PropTypes from "prop-types";
import { Archive } from "@opendate-app/setlist";
import DecisionModal from "./DecisionModal";

const COPY = {
  template: {
    title: (name) => `Archive “${name}”?`,
    description: "It stops appearing in the template picker when you schedule a class. Classes already scheduled from it keep running. You can unarchive it at any time.",
    confirm: "Archive Template",
  },
  instructor: {
    title: (name) => `Archive ${name}?`,
    description: "They stop appearing when you assign instructors to sessions. Sessions they already teach keep them. You can unarchive them at any time.",
    confirm: "Archive Instructor",
  },
};

export default function ArchiveConfirmModal({ kind, name, working = false, onConfirm, onClose }) {
  const copy = COPY[kind];
  return (
    <DecisionModal
      type="warning"
      icon={Archive}
      title={copy.title(name)}
      description={copy.description}
      cancelLabel="Keep Active"
      confirmLabel={working ? "Archiving…" : copy.confirm}
      onConfirm={onConfirm}
      onClose={onClose}
      working={working}
    />
  );
}

ArchiveConfirmModal.propTypes = {
  kind: PropTypes.oneOf(["template", "instructor"]).isRequired,
  name: PropTypes.string,
  working: PropTypes.bool,
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};
